// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2980":"css/admin-app.6691","8060":"css/app.6691"}[chunkId] + ".css";
};